// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iPaE","type":"styles_type__3LCHZ","choices":"styles_choices__3ufxH"};